<template>

  <div class="circle-btn" @click="$refs.authLoginModal.open()">
    <span class="material-symbols-outlined">login</span>

    <span class="circle-btn--animation"></span>
  </div>

  <AuthLoginModal ref="authLoginModal" @emitForgotPassword="recover" @emitRegister="register"/>
  <AuthRecoverModal ref="authRecoverModal" @emitLogin="login"/>
  <AuthRegisterModal ref="authRegisterModal" @emitLogin="login"/>

</template>

<script>

import AuthLoginModal from "@/views/Auth/Part/LoginModal.vue";
import AuthRecoverModal from "@/views/Auth/Part/RecoverModal.vue";
import AuthRegisterModal from "@/views/Auth/Part/RegisterModal.vue";

export default {
  name: "Login",
  components: {
    AuthRegisterModal,
    AuthRecoverModal,
    AuthLoginModal,
  },
  data: () => ({
    context_menu_show: false,
  }),
  methods: {
    recover() {
      this.$refs.authLoginModal.close()
      setTimeout(() => {
        this.$refs.authRecoverModal.open()
      }, 250)
    },

    login() {
      this.$refs.authRecoverModal.close()
      this.$refs.authRegisterModal.close()
      setTimeout(() => {
        this.$refs.authLoginModal.open()
      }, 250)
    },

    register() {
      this.$refs.authLoginModal.close()
      setTimeout(() => {
        this.$refs.authRegisterModal.open()
      }, 250)
    },
  }
}
</script>

<style scoped lang="scss">

.circle-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 0.625rem;
  border: 1px solid #646464;
  color: #646464;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 0.5s ease 0s;
  cursor: pointer;
  user-select: none;

  &:hover {
    border-color: rgb(73, 78, 155);

    & .material-symbols-outlined {
      color: #fff;
    }

    & > .circle-btn--animation {
      opacity: 1;
      visibility: visible;
      transform: scale(1);
    }
  }

  & .material-symbols-outlined {
    transition: all 0.5s ease 0s;
    z-index: 1;
    font-size: 1.25rem;
  }

  &--animation {
    position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    top: -1px;
    left: -1px;
    background-color: rgb(73, 78, 155);
    transition: all 0.5s ease 0s;
    opacity: 0;
    transform: scale(0.2);
    visibility: hidden;
  }
}

html.contrast {

  & .circle-btn {
    border-color: #000;
    color: #000;

    &:hover {
      border-color: yellow;

      & .material-symbols-outlined {
        color: #000;
      }
    }

    &--animation {
      background-color: yellow;
    }
  }
}

</style>